import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import _ from "lodash";

import useUser from '../hooks/useUser';
import { isUrl } from '../helpers/validation';

import '../App.css';

export default function ReviewForm(props) {
  const { user } = useUser();

  const [formTitleInvalid, setFormTitleInvalid] = useState(false);
  const [formBodyInvalid, setFormBodyInvalid] = useState(false);
  const [yelpLinkInvalid, setYelpLinkInvalid] = useState(false);
  const [googleLinkInvalid, setGoogleLinkInvalid] = useState(false);

  const handleValidateChange = (e) => {
    if (e.target.name.indexOf('form') !== -1) {
      const setInvalid = eval('set'+_.upperFirst(e.target.name)+'Invalid');
      if (!e.target.value) {
        setInvalid(true);
        return;
      } else {
        setInvalid(false);
      }
    }
    if (e.target.name.indexOf('Link') !== -1) {
      const setInvalid = eval('set'+_.upperFirst(e.target.name)+'Invalid');
      if (!e.target.value) {
        setInvalid(false);
        return;
      } else {
        setInvalid(!isUrl(e.target.value));
        return;
      }
    }    
  }

  return (
    <Container fluid className="text-start mt-3 mt-md-5">
      <Row>
        <Col></Col>
        <Col xs={12} sm={8}>

          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Review Form Title</Card.Title>
              <p>
                This is the form where customers leave a review. 
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Title</Form.Label>
                  <Form.Control 
                    isInvalid={formTitleInvalid} 
                    type="text" 
                    name="formTitle" 
                    defaultValue={props.formTitle ? props.formTitle : (user ? user.shop.data.saastic_account.data.form_title : '')} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a subject.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Review Form Body</Form.Label>
                  <Form.Control 
                    as="textarea"
                    isInvalid={formBodyInvalid} 
                    type="text" 
                    name="formBody" 
                    defaultValue={props.formBody ? props.formBody : (user ? user.shop.data.saastic_account.data.form_body : '')} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a message.
                  </Form.Control.Feedback>                  
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
          
          <Card className="mb-3">
            <Card.Body>
              <Card.Title>Review Site Links</Card.Title>
              <p>
                You can add or these later if you like.
              </p>
              <Form noValidate>
                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Google Link</Form.Label>
                  <Form.Control 
                    isInvalid={googleLinkInvalid} 
                    type="text" 
                    placeholder="https://" 
                    name="googleLink" 
                    defaultValue={props.googleLink ? props.googleLink : (user ? user.shop.data.saastic_account.data.google_link : '')} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid link.
                  </Form.Control.Feedback>                      
                </Form.Group>

                <Form.Group className="mb-3" controlId="formRequestEmail">
                  <Form.Label>Yelp Link</Form.Label>
                  <Form.Control 
                    isInvalid={yelpLinkInvalid} 
                    type="text" 
                    placeholder="https://" 
                    name="yelpLink" 
                    defaultValue={props.yelpLink ? props.yelpLink : (user ? user.shop.data.saastic_account.data.yelpLink : '')} 
                    onChange={e => props.handleChange(e.target.name, e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid link.
                  </Form.Control.Feedback>                      
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>

        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}
